import { selectOrder } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { useTkv2NullableOrderContext } from './useTkv2NullableControllerOrder.ts';

export const useTkv2OrderID = () => {
  const { orderID: contextOrderID } = useTkv2NullableOrderContext() ?? {};
  const reduxOrderID = useAppSelector(selectOrder).id;

  return contextOrderID ?? reduxOrderID;
};
